import { Navigate, Route, Routes } from "react-router-dom"
import { LoginPage, RecoverPassword } from "../pages"

export const AuthRoutes = () => {
  return (
    <Routes>
        <Route path='/login' element={<LoginPage/>}/> 
        <Route path='/recover' element={<RecoverPassword/>}/> 

        <Route path='/*' element={<Navigate to='/auth/login' />}/>
    </Routes>
  )
}
